<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="fm2">
<p class="center"><strong>“I think playing golf during a war just sends the wrong signal.”</strong></p>
<p class="center"><strong>—George W. Bush</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740798849_epub_fm2_r1.vue?71eb8af0